module.exports = __webpack_public_path__ + "img/default_thumbnail_news.32edfaaa.jpg";